<template>
  <div class="dialog-container" v-loading="isLoading">
    <el-alert class="mb-3" :title="errorMessage" type="error" show-icon v-if="errorMessage"></el-alert>
    <el-row :gutter="18">
      <el-col :span="24">
        <el-form ref="userChangePassword" :model="form" :rules="rules" label-width="30%" @submit.prevent.native>
          <el-form-item label="Password" prop="password">
            <el-input type="password" v-model="form.password" placeholder="Password" @keyup.enter.native="updatePassword"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row :gutter="18" class="dialog-footer">
      <el-col :span="24" class="align-right">
        <el-button @click="closeDialog">Cancel</el-button>
        <el-button type="primary" @click="updatePassword">Update Password</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import api from '@/api';
import { Required, Password } from '@/util/formValidators';

export default {
  name: 'UserChangePasswordDialog',
  props: {
    user: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      isLoading: false,
      errorMessage: '',
      form: {
        password: null,
      },
      rules: {
        password: [Required, Password],
      },
    };
  },
  computed: {
  },
  methods: {
    async updatePassword() {
      this.errorMessage = '';
      try {
        await this.$refs.userChangePassword.validate();
      } catch (e) {
        console.warn('form not valid');
        return;
      }

      this.isLoading = true;
      try {
        await api.user.updatePassword(this.user, this.form.password);
        this.$notify.success({
          title: 'Success',
          message: 'The user\'s password has been updated.',
          position: 'bottom-right',
        });
        this.closeDialog();
      } catch (e) {
        // TODO: if login failed and the user is an admin, give them a password resest option
        this.errorMessage = e || 'An error occurred. Please try again.';
      } finally {
        this.isLoading = false;
      }
    },
    closeDialog() {
      this.form.password = null;
      this.isLoading = false;
      this.errorMessage = '';
      this.$nextTick(() => {
        this.$refs.userChangePassword.resetFields();
      });
      this.$emit('close');
    },
  },
};

</script>
